'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { ErrorState } from './error-state.js';
const changed = (a = [], b = []) => a.length !== b.length || a.some((v, i) => !Object.is(v, b[i]));
/**
 * Error boundary for one panel or region: a render error inside it shows an
 * ErrorState with "Try again" instead of taking down the page. The rest of the
 * page keeps working.
 */
export class ErrorStateBoundary extends Component {
    static displayName = 'ErrorStateBoundary';
    state = { error: null };
    static getDerivedStateFromError(raw) {
        return { error: raw instanceof Error ? raw : new Error(String(raw)) };
    }
    componentDidCatch(error, info) {
        this.props.onError?.(error, info);
    }
    componentDidUpdate(prev) {
        if (this.state.error && changed(prev.resetKeys, this.props.resetKeys))
            this.reset();
    }
    reset = () => {
        this.setState({ error: null });
        this.props.onReset?.();
    };
    render() {
        const { error } = this.state;
        if (!error)
            return this.props.children;
        const { fallback, children: _children, onError: _e, onReset: _r, resetKeys: _k, ...rest } = this.props;
        if (typeof fallback === 'function')
            return fallback({ error, reset: this.reset });
        if (fallback !== undefined)
            return fallback;
        return _jsx(ErrorState, { ...rest, onRetry: this.reset });
    }
}
//# sourceMappingURL=error-state.boundary.js.map